import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("spinner-overlay", () => {
    it("should render correctly in closed state", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-spinner-overlay></ux-spinner-overlay>`);
        const el = await page.find("ux-spinner-overlay");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render correctly in opened state", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-spinner-overlay opened></ux-spinner-overlay>`);
        await new Promise((resolve) => setTimeout(resolve, 800));
        const el = await page.find("ux-spinner-overlay");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-spinner-overlay opened></ux-spinner-overlay>`);
    });

    it("renders with headline and subline correctly when props are set", async () => {
        const page = await newE2EPage();

        await page.setContent(`
      <ux-spinner-overlay opened headline="Test Headline" subline="Test Subline"></ux-spinner-overlay>
    `);

        const headline = await page.find(".ux-spinner-overlay__headline");
        const subline = await page.find(".ux-spinner-overlay__subline");

        expect(headline).toHaveClass("ux-text-headline");
        expect(headline).toHaveClass("ux-text-headline--big");
        expect(headline).toEqualText("Test Headline");

        expect(subline).toHaveClass("ux-text-normal");
        expect(subline).toEqualText("Test Subline");
    });
});
